import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="19.61 41.42 23.17 47.83 47.83 47.83 48 24.45 43.77 19.86 38.93 18.67 29.37 6.18 19.61 41.42"
  />
);

export let SussieAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.sussie}
    renderShadow={renderShadow}
  >
    <>
      <path
        d="M5.25,17.92c0-1.1,14.06-1.59,18.74-1.28,4.93.33,18.46,2.65,19.47,3.41s-14.99.89-20.2.58c-4.37-.26-18.01-1.98-18.01-2.71Z"
        style={{
          fill: '#000',
          stroke: '#000',
          strokeMiterlimit: 10,
        }}
      />
      <path
        d="M16.9,19.83c.32-.14.52-.66.63-1.22.29-1.5.9-2.91,1.9-4.06.93-1.07,2.13-2.1,3.36-2.14,2.6-.1,6.17.1,7.14,4.15s-.23,7.89.35,10.79,2.87,5.09,5.21,6.27c.77,1.42-4.54,8.24-11.77,8.82s-5.17-7.94-5.17-11.48c0-4.38-2.94-5.73-5.4-6.1-3.9-.59.6-3.59,3.76-5Z"
        style={{
          fill: '#364478',
          stroke: '#364478',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M17.5,27.49c-1.16-1.47-3.1-1.97-4.69-2.21-4.05-.62-7.06.13-7.28.18.1-.26,1.94-4.32,11.34-5.58,1.88.42,4.3,4.79.63,7.61Z"
        style={{
          fill: '#1d202e',
          stroke: '#000',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M19.3,22.98c-1.09-.08-1.62-.15-2.55-.14-.16,0-.82.61-.82.61,0,0-.71-.61-.89-.61-.85.03-.93.1-1.63.18-.19.02-.89.67-.89.67,0,0-.77-.56-.97-.53-.87.14-4.05.52-6.02,2.27"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M17.75,28.71c-.21-.11-.36-.33-.36-.58,0-.36.29-.65.65-.65s.65.29.65.65-.29.65-.65.65c-.34,0-.6-.07-.9.16-.17.13-.28.36-.23.57.04.15.16.27.2.41.06.21-.05.44-.21.58s-.38.22-.58.3"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <g>
        <g>
          <path
            d="M22.93,23.76c-1.45,0-2.63-1.18-2.63-2.63s1.18-2.63,2.63-2.63,2.62,1.18,2.62,2.63-1.18,2.63-2.62,2.63Z"
            style={{ fill: '#fff020' }}
          />
          <path d="M22.93,19.01c1.17,0,2.13.95,2.13,2.13s-.95,2.13-2.13,2.13-2.13-.95-2.13-2.13.95-2.13,2.13-2.13M22.93,18.01c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13,3.13-1.4,3.13-3.13-1.4-3.13-3.13-3.13h0Z" style={{ fill: '#000' }} />
        </g>
        <g>
          <path d="M20.41,20.48c.3-1.12,1.33-1.94,2.54-1.94,1.07,0,2.01.64,2.42,1.59l-4.96.35Z" style={{ fill: '#000' }} />
          <path d="M22.96,19.04c.6,0,1.15.25,1.54.65l-3.27.23c.39-.54,1.02-.88,1.73-.88M22.96,18.04c-1.68,0-3.05,1.33-3.13,2.98l6.2-.44c-.27-1.45-1.54-2.55-3.07-2.55h0Z" style={{ fill: '#000' }} />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M25.21,30.22c-1.45,0-2.63-1.18-2.63-2.62s1.18-2.63,2.63-2.63,2.62,1.18,2.62,2.63-1.18,2.62-2.62,2.62Z"
            style={{ fill: '#fff020' }}
          />
          <path d="M25.21,25.47c1.17,0,2.13.95,2.13,2.13s-.95,2.13-2.13,2.13-2.13-.95-2.13-2.13.95-2.13,2.13-2.13M25.21,24.47c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13,3.13-1.4,3.13-3.13-1.4-3.13-3.13-3.13h0Z" style={{ fill: '#000' }} />
        </g>
        <g>
          <path d="M22.7,26.94c.3-1.12,1.33-1.94,2.54-1.94,1.07,0,2.01.64,2.42,1.59l-4.96.35Z" style={{ fill: '#000' }} />
          <path d="M25.24,25.5c.6,0,1.15.25,1.54.65l-3.27.23c.39-.54,1.02-.88,1.73-.88M25.24,24.5c-1.68,0-3.05,1.33-3.13,2.98l6.2-.44c-.27-1.45-1.54-2.55-3.07-2.55h0Z" style={{ fill: '#000' }} />
        </g>
      </g>
      <g>
        <g>
          <path
            d="M28.34,36.48c-1.45,0-2.62-1.18-2.62-2.63s1.18-2.63,2.62-2.63,2.63,1.18,2.63,2.63-1.18,2.63-2.63,2.63Z"
            style={{ fill: '#fff020' }}
          />
          <path d="M28.34,31.72c1.17,0,2.13.95,2.13,2.13s-.95,2.13-2.13,2.13-2.13-.95-2.13-2.13.95-2.13,2.13-2.13M28.34,30.72c-1.73,0-3.13,1.4-3.13,3.13s1.4,3.13,3.13,3.13,3.13-1.4,3.13-3.13-1.4-3.13-3.13-3.13h0Z" style={{ fill: '#000' }} />
        </g>
        <g>
          <path d="M25.82,33.19c.3-1.12,1.33-1.94,2.54-1.94,1.07,0,2.01.64,2.42,1.59l-4.96.35Z" style={{ fill: '#000' }} />
          <path d="M28.37,31.75c.6,0,1.15.25,1.54.65l-3.27.23c.39-.54,1.02-.88,1.73-.88M28.37,30.75c-1.68,0-3.05,1.33-3.13,2.98l6.2-.44c-.27-1.45-1.54-2.55-3.07-2.55h0Z" style={{ fill: '#000' }} />
        </g>
      </g>
      <path
        d="M18.69,27.78c5.79-2.95,8.95-4.12,9.22-10.99"
        style={{
          fill: 'none',
          stroke: '#000',
          strokeLinecap: 'round',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <path
        d="M42.65,19.71c-.19-.15,0,0-.95-.23-2.6-.64-7.48-1.51-11.74-2.12l-.92-10.88-.19-.03c-2.51-.41-5.05-.62-7.59-.62h0l-2.96,10.75c-5.81.09-12.76.31-12.76,1.09,0,0,.27.26,1.17.26,3.45,0,12.35.04,18.12.41,7.28.47,17.82,1.38,17.82,1.38Z"
        style={{
          fill: '#10121a',
          stroke: '#000',
          strokeMiterlimit: 10,
          strokeWidth: 0.75,
        }}
      />
      <polygon
        points="27.29 7.3 28.1 7.46 28.84 16.28 27.69 16.12 27.29 7.3"
        style={{ fill: '#454370' }}
      />
    </>
  </AvatarArtwork>
);
